import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col items-start gap-3">
      <h1 className="text-xl font-bold text-slate-900">{t('pages.notFound.title')}</h1>
      <p className="text-sm text-slate-600">{t('pages.notFound.body')}</p>
      <Link to="/" className="text-sm font-medium text-brand-700 hover:underline">
        {t('nav.dashboard')}
      </Link>
    </section>
  );
}
